import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FeatureFlag, useFeatureFlagResolved } from '@/services/featureFlag.service';
import AgentsNav from './AgentsNav';
import { AGENTS_PATH } from './data';

/**
 * Route layout for every Agents screen, like the Data Model's: the agents and connections tree
 * on the left and the routed page to its right, which owns its own header and fills the pane
 * (`flex-1 min-h-0 flex flex-col`). With agents-v2 off, /agents is the scheduled Ellie agents'
 * page (Agents.tsx) and every other Agents screen goes back to it.
 */
export default function AgentsLayout() {
  const { value: v2, isLoading } = useFeatureFlagResolved(FeatureFlag.AGENTS_V2, false);
  const { pathname } = useLocation();
  const overview = pathname.replace(/\/$/, '') === AGENTS_PATH;
  if (!overview && !v2) return isLoading ? null : <Navigate to={AGENTS_PATH} replace />;
  return (
    <div className="w-full flex flex-col bg-background overflow-hidden" style={{ height: 'calc(100vh)' }}>
      <div className="flex-1 min-h-0 overflow-hidden flex">
        {v2 && <AgentsNav />}
        <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
